"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthTokenForEndpoint = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
const needle_1 = require("./needle");
/**
 * Retrieves an authentication token for endpoint.
 *
 * Authentication uses the general HTTP authentication framework.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Authentication
 *
 * @returns Returns authentication token when endpoint requires authentication.
 * @returns Returns null when endpoint does not require authentication.
 * @throws Throws when credentials are invalid.
 */
async function getAuthTokenForEndpoint(registryBase, endpoint, username, password, reqOptions = {}) {
    var _a, _b;
    const reqConfig = (0, registry_call_1.buildUnauthenticatedV2RequestConfig)(registryBase, endpoint, contentTypes.JSON, reqOptions);
    try {
        await (0, needle_1.needleWrapper)(reqConfig);
        return null;
    }
    catch (err) {
        // check if artifactory is redirecting to landing page (deactivated instance, see #incident-2244-test-jfrog-artifactory-inactive for more details)
        if (err.statusCode === 302 &&
            ((_b = (_a = err.headers) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.includes("landing.jfrog.com"))) {
            throw new Error(`Artifactory instance appears to be deactivated (redirected to ${err.headers.location})`);
        }
        if (err.statusCode !== 401) {
            throw err;
        }
        const challengeHeaders = err.headers["www-authenticate"];
        if (!challengeHeaders) {
            return null;
        }
        const [authBase, service, scope] = (0, registry_call_1.parseChallengeHeaders)(challengeHeaders);
        if (!authBase) {
            return null;
        }
        else {
            // Bearer token
            const token = await (0, registry_call_1.getToken)(registryBase, authBase, service, scope, username, password, reqOptions);
            return token;
        }
    }
}
exports.getAuthTokenForEndpoint = getAuthTokenForEndpoint;
//# sourceMappingURL=get-auth-token-for-endpoint.js.map